import { BasicResponseDTO } from "@dto/basicResponse.dto";
import { Button } from "antd";
import { AxiosError } from "axios";
import { FC } from "react";
import { getErrorMessage } from "src/util/axiosError";
import { GLOB } from "src/util/Glob";
import './ErrorPage.less';

/** Shown instead of the app shell when start-up requests fail because the backend is unreachable */
export const BackendUnavailable: FC<{ error: AxiosError<BasicResponseDTO>; }> = ({ error }) => (
  <div id="error-page" style={{ padding: "2em" }}>
    <h2>XorMon backend is not available</h2>
    <p>The server did not answer. It may be starting up or restarting after an upgrade.</p>
    <pre>{getErrorMessage(error)}</pre>
    <Button type="primary" onClick={() => GLOB.authService.retryInit()}>Retry</Button>
  </div>
);
